import React from 'react';
import VideoSlider from '../shared/VideoSlider';

const Video = ({ content }) => {
  return (
    <VideoSlider post={content} />  
  )
}

export default Video;